'use client';

import { FC } from 'react';
import styles from './PlpFiltersRange.module.scss';
import { FilterOption, PlpFiltersConditionalProps } from '../../PlpFilters.type';
import { FilterSelectItem } from '../Fields/FilterSelectItem';

export type PricingMode = 'cash' | 'finance';
type Props = {
  minOptions: FilterOption[];
  maxOptions: FilterOption[];
  minValue?: string | number;
  maxValue?: string | number;
  minPlaceholder?: string;
  maxPlaceholder?: string;
} & PlpFiltersConditionalProps;

export const PlpFiltersRange: FC<Props> = ({
  minOptions,
  maxOptions,
  minValue,
  maxValue,
  minPlaceholder,
  maxPlaceholder,
  ...props
}) => {
  return (
    <div className={styles.root}>
      <FilterSelectItem
        name={'min'}
        id={'min'}
        options={minOptions}
        size="small"
        className={styles.selectRange}
        defaultValue={minValue}
        placeholder={minPlaceholder}
        data-testid="filter-range-min"
        {...props}
      />
      <FilterSelectItem
        name={'max'}
        id="max"
        options={maxOptions}
        size="small"
        className={styles.selectRange}
        defaultValue={maxValue}
        placeholder={maxPlaceholder}
        data-testid="filter-range-max"
        {...props}
      />
    </div>
  );
};
